module.exports = __webpack_public_path__ + "img/verticalgamecover6x9_template.6d23d634.jpg";